'use client'

import { useEffect } from 'react'
import clsx from 'classnames'
import { motion, useAnimate } from 'framer-motion'
import { callCallbackWithDelay } from '@/shared/utils'
import './preloader2.scss'

export const NewPreloader = ({ loaded }) => {
  const [svgRef, svgAnimate] = useAnimate()
  const [group1Ref, group1Animate] = useAnimate()
  const [group2Ref, group2Animate] = useAnimate()
  const [group3Ref, group3Animate] = useAnimate()
  const [group4Ref, group4Animate] = useAnimate()

  useEffect(() => {
    const anime1 = group1Animate(
      group1Ref.current,
      { rotate: 360 },
      {
        duration: 3,
        repeat: Infinity,
        ease: 'linear',
      }
    )
    const anime2 = group2Animate(
      group2Ref.current,
      { rotate: -360 },
      {
        duration: 4,
        repeat: Infinity,
        ease: 'linear',
      }
    )
    const anime3 = group3Animate(
      group3Ref.current,
      { rotate: 360 },
      {
        duration: 3,
        repeat: Infinity,
        ease: 'linear',
      }
    )
    const anime4 = group4Animate(
      group4Ref.current,
      { rotate: -360 },
      {
        duration: 2,
        repeat: Infinity,
        ease: 'linear',
      }
    )

    if (loaded) {
      let speed = 0.9
      anime1.speed = speed
      anime2.speed = speed
      anime3.speed = speed
      anime4.speed = speed

      svgAnimate(svgRef.current, { '--scale-svg': 4.2, '--stroke-scale': 1.35 }, { duration: 1 })
      callCallbackWithDelay(
        () => {
          speed -= 0.03
          if (speed >= 0.05) {
            anime1.speed = speed
            anime2.speed = speed
            anime3.speed = speed
            anime4.speed = speed
          }
        },
        40,
        50
      )
    }
  }, [loaded])

  return (
    <motion.svg
      ref={svgRef}
      initial={{ '--scale-svg': 1, '--stroke-scale': 1 }}
      className={clsx('loader')}
      fill="none"
      viewBox="0 0 450 450"
    >
      <motion.g ref={group1Ref} className="circle" id="rotatingGroup1" strokeWidth="calc(3 * var(--stroke-scale, 1))">
        <path stroke="url(#g)" d="M203.9 209.4c-7 9.4-6.7 22.1 0 31.1" />
        <path stroke="url(#h)" d="M205.3 242.4a26.3 26.3 0 0 0 33 5.2" />
        <path stroke="url(#i)" d="M205.8 207.1c8.4-9.1 22.2-11 32.9-4.5" />
      </motion.g>

      <motion.g ref={group2Ref} className="circle" id="rotatingGroup2" strokeWidth="calc(4 * var(--stroke-scale, 1))">
        <path stroke="url(#j)" d="M267.2 256.3c14-19 13.4-44.3 0-62.4" />
        <path stroke="url(#k)" d="M264.3 190.2a52.8 52.8 0 0 0-66-10.3" />
        <path stroke="url(#l)" d="M263.5 260.8a52.5 52.5 0 0 1-65.9 9" />
      </motion.g>

      <motion.g ref={group3Ref} className="circle" id="rotatingGroup3" strokeWidth="calc(5 * var(--stroke-scale, 1))">
        <path stroke="url(#d)" d="M178 161.7a78.8 78.8 0 0 1 93.6-.1" />
        <path stroke="url(#e)" d="M277.1 166a79.1 79.1 0 0 1 15.6 99" />
        <path stroke="url(#f)" d="M171.4 167.3a78.8 78.8 0 0 0-13.6 98.8" />
      </motion.g>

      <motion.g ref={group4Ref} className="circle" id="rotatingGroup4" strokeWidth="calc(6 * var(--stroke-scale, 1))">
        <path stroke="url(#a)" d="M287.6 309.4a105 105 0 0 1-124.7.2" />
        <path stroke="url(#b)" d="M155.5 303.6a105.4 105.4 0 0 1-20.8-132" />
        <path stroke="url(#c)" d="M296.5 302a105 105 0 0 0 18.1-131.8" />
      </motion.g>

      <defs>
        <linearGradient id="a" x1="212" x2="175.2" y1="355.5" y2="292.3" gradientUnits="userSpaceOnUse">
          <stop stopColor="#023874" />
          <stop offset="1" stopColor="#0A0D2B" stopOpacity="0" />
        </linearGradient>
        <linearGradient id="b" x1="152.4" x2="111.8" y1="290.2" y2="184.3" gradientUnits="userSpaceOnUse">
          <stop stopColor="#E53B35" />
          <stop offset="1" stopColor="#0A0D2B" stopOpacity="0" />
        </linearGradient>
        <linearGradient id="c" x1="299.5" x2="256" y1="287.1" y2="204.4" gradientUnits="userSpaceOnUse">
          <stop stopColor="#023874" />
          <stop offset="1" stopColor="#0A0D2B" stopOpacity="0" />
        </linearGradient>
        <linearGradient id="d" x1="234.8" x2="262.3" y1="127.1" y2="174.5" gradientUnits="userSpaceOnUse">
          <stop stopColor="#023874" />
          <stop offset="1" stopColor="#0A0D2B" stopOpacity="0" />
        </linearGradient>
        <linearGradient id="e" x1="279.5" x2="309.9" y1="176.1" y2="255.5" gradientUnits="userSpaceOnUse">
          <stop stopColor="#E53B35" />
          <stop offset="1" stopColor="#0A0D2B" stopOpacity="0" />
        </linearGradient>
        <linearGradient id="f" x1="169.1" x2="201.7" y1="178.4" y2="240.4" gradientUnits="userSpaceOnUse">
          <stop stopColor="#023874" />
          <stop offset="1" stopColor="#0A0D2B" stopOpacity="0" />
        </linearGradient>
        <linearGradient id="g" x1="192.4" x2="208.2" y1="228.3" y2="237.4" gradientUnits="userSpaceOnUse">
          <stop stopColor="#023874" />
          <stop offset="1" stopColor="#0A0D2B" stopOpacity="0" />
        </linearGradient>
        <linearGradient id="h" x1="208.7" x2="235.2" y1="243.2" y2="253.3" gradientUnits="userSpaceOnUse">
          <stop stopColor="#E53B35" />
          <stop offset="1" stopColor="#0A0D2B" stopOpacity="0" />
        </linearGradient>
        <linearGradient id="i" x1="209.5" x2="230.1" y1="206.4" y2="217.2" gradientUnits="userSpaceOnUse">
          <stop stopColor="#023874" />
          <stop offset="1" stopColor="#0A0D2B" stopOpacity="0" />
        </linearGradient>
        <linearGradient id="j" x1="290.3" x2="258.7" y1="218.5" y2="200.1" gradientUnits="userSpaceOnUse">
          <stop stopColor="#023874" />
          <stop offset="1" stopColor="#0A0D2B" stopOpacity="0" />
        </linearGradient>
        <linearGradient id="k" x1="257.6" x2="204.6" y1="188.7" y2="168.4" gradientUnits="userSpaceOnUse">
          <stop stopColor="#023874" />
          <stop offset="1" stopColor="#0A0D2B" stopOpacity="0" />
        </linearGradient>
        <linearGradient id="l" x1="256.1" x2="214.7" y1="262.3" y2="240.5" gradientUnits="userSpaceOnUse">
          <stop stopColor="#E53B35" />
          <stop offset="1" stopColor="#0A0D2B" stopOpacity="0" />
        </linearGradient>
      </defs>
    </motion.svg>
  )
}
